import React, { useState } from 'react'
import { Container, Top } from '../../styles'
import { DefaultUserPage } from '../../../DefaultPages'

import { Breadcrumbs, Tab } from '../../../../components'
import { UserBrandDetailsTabs } from '../../../../constants/userBrand'
import UserCertificates from './UserCertificates'

const UserBrandDetails = () => {
  const [tabName, setTabName] = useState(UserBrandDetailsTabs.CERTIFICATES)

  return (
    <DefaultUserPage page="brands">
      <Container>
        <Top>
          <Breadcrumbs />
        </Top>
        <Tab margin="1.5rem 0 0 0">
          <Tab.Item
            name="tabName"
            label="Certificados"
            onClick={() => setTabName(UserBrandDetailsTabs.CERTIFICATES)}
            checked={tabName === UserBrandDetailsTabs.CERTIFICATES}
          />
        </Tab>

        {tabName === UserBrandDetailsTabs.CERTIFICATES && <UserCertificates />}
      </Container>
    </DefaultUserPage>
  )
}

export default UserBrandDetails
